import React from 'react';

const Footer = (props) => (
  <footer
    className={`
        allo bg-gradient-to-br from-blue-300 to-green-300 flex justify-evenly flex-wrap content-center h-14 footer lg:mt-32 mt-16 lg:32
      `}>
    <p className='text-base lg:text-xl font-assistant'>כתובת: קרן המוזיקה 2 כפר סבא</p>
    <p className='text-base lg:text-xl font-assistant'>טלפון: 058-4549797</p>
    <p className='text-base lg:text-xl font-assistant'>דוא"ל: sharon@reshet-cs.co.il</p>
  </footer>
);

export default Footer;
